module.exports = __webpack_public_path__ + "media/svg/listing_apply-ccf72847.svg";